import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Typography from '@mui/material/Typography'
import InputBase from '@mui/material/InputBase'
import Paper from '@mui/material/Paper'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import { visuallyHidden } from '@mui/utils'
import AppBar from '../components/app-bar'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { MenuItem, CircularProgress, Button, Dialog, DialogTitle, DialogActions, AccordionDetails, makeStyles, Select, TextField, ListItemText, Checkbox } from '@material-ui/core'
import { customTheme } from '../styling'
import axios from '../axios'
import moment from 'moment'
import GeneralError from '../components/error'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import { List, ListItem, Popover, Tab, Tabs } from '@mui/material'
import { getRoleUserIdFromToken } from '../utils'
import { SearchBar } from '../components/search-bar.tsx'

const useStyles = makeStyles((theme) => ({
    generateCodeContainer: {
        width: '100%',
        marginTop: '1.5rem',
    },
    appBarSpacer: theme.mixins.toolbar,
    uploadFile: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginLeft: '1rem',
        width: '90%',
        height: '20vh',
        display: 'flex',
        textAlign: 'center',
        border: `1px solid ${customTheme.colors.ui.grey}`,
        borderStyle: 'dotted',
        marginBottom: '0.3rem'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: '100vh',
        overflow: 'auto',
    },
    title: {
        color: 'black',
    },
    selectBoxMain: {
        width: '80vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        position: 'absolute',
        top: '40%',
        cursor: 'pointer'
    },
    selectBox: {
        width: '35%',
        backgroundColor: customTheme.colors.ui.ligthBlue,
        padding: '1.5rem 3.5rem',
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
            opacity: '0.8'
        },
    },
    loadingContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    formControl: {
        minWidth: 300, marginRight: '1.5rem'
    },
    dialogActions: {
        marginTop: '1rem'
    },
    contentContainer: {
        padding: '2rem'
    },
    textarea: {
        fontSize: '1rem',
        border: '1px solid #000',
        paddingLeft: '0.5rem',
        paddingTop: '0.5rem',
        resize: 'none',
        width: '100%',
        borderRadius: '8px',
        height: '30vh',
        '&:focus': {
          outline: 'none !important',
          outlineColor: customTheme.colors.ui.grey,
          border: `1px solid ${customTheme.colors.ui.grey} !important`
        },
      },

}))



const rows = []



const headCells = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: 'Codice agente',
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Agente',
    },
    {
        id: 'clients',
        numeric: false,
        disablePadding: false,
        label: 'Clienti associati',
    },
]

const EnhancedTableHead = (props) => {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead style={{ backgroundColor: customTheme.colors.ui.greyLight, }}>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        style={{color:'black'}}
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                       {headCell.label}
                    </TableCell>
                    
                ))}
                 
<TableCell

> </TableCell>
            </TableRow>
        </TableHead>
    )
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const Agents = () => {
    const [clients, setClients] = useState([])
    const [clientSelected, setClientSelected] = useState([])
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('calories')
    const [selected, setSelected] = React.useState([])
    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(3)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [addAgentOpen, setAddAgentOpen] = useState(false)
    const [creatingAgent, setCreatingAgent] = useState(false)
    const [agents, setAgents] = useState([])
    const [nameCompany, setNameCompany] = useState(null)
    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)
    const [username, setUsername] = useState(null)
    const [fiscalCode, setFiscalCode] = useState(null)
    const [pIva, setPIva] = useState(null)
    const [telNumber, setTelNumber] = useState(null)
    const [addressShipment, setAddressShipment] = useState(null)
    const [registeredOffice, setRegisteredOffice] = useState(null)
    const [longDescription, setLongDescription] = useState(null)
    const [tab, setTab] = useState(0)
    const [anchorElModifyClient, setAnchorElModifyClient] = useState(null)
    const [currentAgent, setCurrentAgent] = useState(null)
    const [unitAvailable, setUnitAvailable] = useState(null)
    const [price, setPrice] = useState(null)
    const classes = useStyles()
    const { enqueueSnackbar } = SnackBar.Consumer()
    const [currentInputSearch, setCurrentInputSearch] = useState('')
    const [confirmDeleteAgent, setConfirmDeleteAgent] = useState(false)
    const [currentAgentId, setCurrentAgentId] = useState(null)
    const openModifyClient = Boolean(anchorElModifyClient)
    const idModifyClient = openModifyClient ? 'simple-popover-modify-client' : undefined
    const [deletingAgent, setDeletingAgent] = useState(false)
 

    const handleDeleteAgent = () => {
        setDeletingAgent(true)
        axios.post('/delete-agent', { id: currentAgentId }).then((res) => {
        setAgents(agents.filter(({ id }) => id !== currentAgentId))
        setCurrentAgentId(null)
        setDeletingAgent(false)
        setConfirmDeleteAgent(false)
        enqueueSnackbar('Cliente elliminato correttamente', {
            variant: 'success',
        })
    }).catch((error) => {
        console.log('ERROR', error)
      if (error.status === 400) {
        enqueueSnackbar(error.response.data.message, {
          variant: 'error',
        })
      } else {
        enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
          variant: 'error',
        })
      }
      setDeletingAgent(false)
    })
      }

    const getAgents = async (status=1, search=null) => {
        let url = '/get-list-agents'
        if(search){
            url = `/get-list-agents?search=${currentInputSearch}`
        }
        const agents = await axios.get(url)
        const agentsData = agents.data
        return agentsData
    }

    const roleUserId = getRoleUserIdFromToken()

    const getInitialData = async () => {
        const agents = await getAgents()
        const clients = await axios.get('/get-list-clients?agentId=0')
        return { agents: agents,clients }
    }

    useEffect(() => {
        setLoading(true)
        getInitialData().then((res) => {
            setAgents(res.agents)
            setClients(res.clients.data)
        }).catch((error) => {
            setError(true)
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }


    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }    


    const handleSave = () => {
        const clientsId = clients.filter(({nameCompany}) => clientSelected.includes(nameCompany)).map(({id}) => id)
        const body = {
            firstName,
            lastName,
            roleUserId: 2,
            pIva,
            username,
            fiscalCode,
            telNumber,
            addressShipment,
            registeredOffice,
            nameCompany,
            clients:clientsId
        }
        
        if(currentAgent){
            body.id = currentAgent.id
        }
        setCreatingAgent(true)
        axios.post(`/create-user`, body).then(() => {
            handleCloseAddUser()
            setCurrentAgent(null)
            enqueueSnackbar({ variant: 'success', message: currentAgent ? 'Agente salvato correttamente' :'Agente creato correttamente' })
            getInitialData().then((res) => {
                setAgents(res.agents)
                setClients(res.clients.data)
            }).catch((error) => {
                setError(true)
            }).finally(() => {
                setLoading(false)
            })

        }).catch((error) => {
            console.log(error)
            if (error.status === 400) {
                enqueueSnackbar(error.response.data.message, {
                  variant: 'error',
                })
              } else {
                enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                  variant: 'error',
                })
              }
        }).finally(() => {
            setCreatingAgent(false)
        })
    }
 


    const handleInputSearchChange = (event) => {
        setCurrentInputSearch(event.target.value)
    }

    const handleSearchAgents = () => {
        setLoading(true)
        getAgents(tab +1, currentInputSearch).then((res) => {
          setAgents(res)
          setLoading(false)
        }).catch(() => {
          setLoading(false)
          enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
            variant: 'error',
          })
    
        })
      }

      const handleCloseAddUser = () => {
        setAddAgentOpen(false)
        setFirstName(null)
        setLastName(null)
        setNameCompany(null)
        setPIva(null)
        setFiscalCode(null)
        setAddressShipment(null)
        setRegisteredOffice(null)
        setUsername(null)
        setTelNumber(null)
    }   

      const handleClearInput = () => {
        setCurrentInputSearch('')
        getAgents(tab + 1).then((res) => {
            setAgents(res)
            setLoading(false)
          }).catch(() => {
            setLoading(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
              variant: 'error',
            })
      
          })
      }





    return (
        <AppBar>
            <Dialog  open={confirmDeleteAgent}>
            <CloseIcon onClick={() => setConfirmDeleteAgent(false)} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
        <Box style={{ width: '25rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
          <List>
            <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box style={{ width: '25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <Typography>Sei sicuro di voler eliminare questo agente?</Typography>

                <Box display={'flex'} flexDirection={'row'}>
                  <Button onClick={() => {
                    setConfirmDeleteAgent(false)
                  }} style={{ marginTop: '1rem', width: '6rem', marginRight: '1rem' }} variant='contained' color='default'>{'Annulla'}</Button>
                  <Button onClick={() => handleDeleteAgent()} style={{ marginTop: '1rem', width: '6rem', backgroundColor: customTheme.colors.ui.red, color: 'white' }} variant='contained'>{deletingAgent ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Ellimina'}</Button>
                </Box>




              </Box>
            </ListItem>
          </List>
        </Box>
      </Dialog>
            <Dialog
                fullWidth={true}
                maxWidth="md"
                className={classes.dialogContainer}
                open={addAgentOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={() => handleCloseAddUser()} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
                <Box className={classes.contentContainer}>
                    <Box className={classes.titleContainer}>
                        <DialogTitle id="alert-dialog-title" className={classes.title}>
                            Dettagli agente
                        </DialogTitle>
                    </Box>
                    <div>
                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Nome 
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Nome' fullWidth={true} variant='outlined' value={firstName} onChange={event => setFirstName(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Cognome 
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Cognome' fullWidth={true} variant='outlined' value={lastName} onChange={event => setLastName(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Nome società
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Nome società' fullWidth={true}  variant='outlined'  value={nameCompany} onChange={event => setNameCompany(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                           
                            
                        </Box>

                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                   Partita IVA
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Partita IVA' fullWidth={true}  variant='outlined' value={pIva} onChange={event => setPIva(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Codice fiscale
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Codice fiscale' fullWidth={true}  variant='outlined'  value={fiscalCode} onChange={event => setFiscalCode(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>
                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                           
                            <Box width={'100%'}>
                                <AccordionDetails>
                                    Sede Legale
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Indirizzo sede Legale' fullWidth={true}  variant='outlined' value={registeredOffice} onChange={event => setRegisteredOffice(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>

                        {roleUserId !== 2 && <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                           
                           <Box width={'100%'}>
                               <AccordionDetails>
                                 Clienti
                               </AccordionDetails>
                               <AccordionDetails>
                               <Select
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null
                          }}
                          
                          multiple
                          style={{width:'100%',}}
                          variant='outlined'
                          labelId="demo-multiple-checkbox-label"
                          id="demo-simple-select"
                          renderValue={(selected) => selected.join(', ')}
                          value={clientSelected}
                          onChange={(event) => {
                            const value = event.target.value
                            setClientSelected(
                            // On autofill we get a stringified value.
                            typeof value === 'string' ? value.split(',') : value,
                            )
                          }}
                        >
                          {clients.map(({ id, nameCompany }) => {
                            return <MenuItem key={id} value={nameCompany}>
                              <Checkbox color='primary' checked={clientSelected.includes(nameCompany)} />
                              <ListItemText primary={nameCompany} />
                            </MenuItem>
                          })}

                        </Select>
                               </AccordionDetails>
                           </Box>
                           
                       </Box>
                        }
                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                            {/* <Box width={'50%'}>
                                <AccordionDetails>
                                   Email di contatto
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Email di contatto'  fullWidth={true} variant='outlined' value={username} onChange={event => setUsername(event.target.value)} />
                                </AccordionDetails>
                            </Box> */}
                            <Box width={'50%'}>
                                <AccordionDetails>
                                Numero di contatto
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Numero di contatto' fullWidth={true}  variant='outlined'  value={telNumber}  onChange={event => setTelNumber(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>



                    </div>
                    <DialogActions className={classes.dialogActions}>
                        <Button style={{ width: '12rem' }} onClick={() => {
                            handleCloseAddUser()
                        }} variant='contained' color='default'>Annulla</Button>
                        <Button style={{ width: '12rem' }} onClick={() => handleSave()} variant='contained' color='primary'>
                            {creatingAgent ? <CircularProgress style={{ color: 'white' }} size={22} /> : 'Salva agente'}
                        </Button>
                    </DialogActions>

                </Box>
            </Dialog>
            {error ? <GeneralError /> : loading ?
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Typography className={classes.title} variant="h5" gutterBottom component="h2">
                        Agenti
                    </Typography>

                    <Box className={classes.loadingContainer}>
                        <CircularProgress />
                    </Box>
                </main>
                :
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />

                    <Typography style={{float:'left'}} className={classes.title} variant="h5" gutterBottom component="h2">
                        Agenti
                    </Typography>

                   

                    <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        style={{ height: '2.5rem', float: 'right', width: '200px', color: customTheme.colors.ui.green, border: `1px solid ${customTheme.colors.ui.green}` }}
                        onClick={() => setAddAgentOpen(true)}
                    >
                        Aggiungi agente
                    </Button>
                    {/* <Box
                        component="form"
                        style={{ height: '2.5rem', borderRadius: '5px', border: `1px solid ${'black'}`, alignItems: 'center', width: 300, float: 'right', marginRight: '1rem' }}
                    >
                        <Button sx={{ padding: '5px', color: 'black' }} onClick={() => currentInputSearch && handleSearchAgents()}>
                            <SearchIcon color='black' />
                        </Button>
                        <InputBase
                            value={currentInputSearch}
                            sx={{ ml: 1, flex: 1 }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    if (currentInputSearch) {
                                        handleSearchAgents()
                                    }
                                    // Do code here
                                    event.preventDefault()
                                }
                            }}
                            placeholder="Cerca..."
                            inputProps={{ 'aria-label': 'Cerca' }}
                            onChange={(event) => handleInputSearchChange(event)}
                        />

                        <CloseIcon onClick={() => handleClearInput()} style={{ position: 'relative', left: '1.5rem', cursor: 'pointer', top: '0.4rem' }} />



                    </Box> */}
                    <SearchBar
                        placeholder='Cerca Agenti …'
                        value={currentInputSearch}
                        onChange={handleInputSearchChange}
                        onSearch={handleSearchAgents}
                        onClear={handleClearInput}
                        sx={{ marginRight: '1rem' }}
                    />

                    <Paper sx={{ width: '100%', marginTop: '5rem' }}>
                        <TableContainer>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                size={'medium'}
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                />
                                <TableBody>
                                    {agents.map((row, index) => {

                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={row.id}
                                                sx={{ cursor: 'pointer' }}
                                            >

                                                <TableCell align="left" >{row.id}</TableCell>
                                                <TableCell align="left" >{row.nameCompany}</TableCell>
                                                <TableCell align="left" >{row.clients.map(({nameCompany}) => nameCompany).join('; ')}</TableCell>
                                                <TableCell aria-describedby={idModifyClient}  align="left" style={{}}>
                                                    <Box style={{display:'flex', flexDirection:'row'}}>
                                                    <span style={{
                                                        
                                                    color:customTheme.colors.ui.grey, textDecoration:'underline', cursor:'pointer'
                                                }} onClick={(event) => {
                                                    setCurrentAgent(row)
                                                    setFirstName(row?.firstName)
                                                    setLastName(row?.lastName)
                                                    setNameCompany(row?.nameCompany)
                                                    setPIva(row?.pIva)
                                                    setFiscalCode(row?.fiscalCode)
                                                    setAddressShipment(row?.addressShipment)
                                                    setRegisteredOffice(row?.registeredOffice)
                                                    setUsername(row?.username)
                                                    setTelNumber(row?.telNumber)
                                                    setAddAgentOpen(true)
                                                    setClientSelected(row.clients.map(({nameCompany}) => nameCompany))
                                                    setClients([...row.clients, ...clients])
                                                }}>Dettagli</span>
                                                <DeleteForeverIcon onClick={() => {
                                                    setConfirmDeleteAgent(true)
                                                    setCurrentAgentId(row.id)
                                                }} style={{ cursor:'pointer', color:customTheme.colors.ui.red, marginLeft:'1rem', position:'relative',}} />
                                                </Box>
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>



                </main>
            }
        </AppBar>
    )
}

export default Agents